{
  "list": {
    "title": "Smart Phrases",
    "backToDashboard": "Dashboard",
    "newButton": "New Phrase",
    "import": "Import",
    "export": "Export",
    "searchPlaceholder": "Search by key or expansion text...",
    "filterAllCategories": "All Categories",
    "header": "Phrases ({{count}})",
    "loading": "Loading phrases...",
    "empty": "No phrases found. Create your first smart phrase.",
    "authoredBy": "by {{name}}",
    "tooltips": {
      "preview": "Preview",
      "edit": "Edit",
      "delete": "Delete"
    },
    "confirmDelete": "Confirm",
    "cancelDelete": "Cancel",
    "previewLabel": "Preview:",
    "closePreview": "Close preview",
    "toast": {
      "deleted": "Phrase deleted",
      "importComingSoon": "Import functionality coming soon",
      "exportComingSoon": "Export functionality coming soon"
    }
  },
  "form": {
    "editTitle": "Edit Smart Phrase",
    "createTitle": "New Smart Phrase",
    "fields": {
      "key": "Key",
      "category": "Category",
      "expansionText": "Expansion Text"
    },
    "required": "*",
    "keyPlaceholder": ".normalexam",
    "keyHelper": "Must start with \".\"",
    "categoryUncategorized": "Uncategorised",
    "expansionPlaceholder": "Text that will replace the shortcut...",
    "cancel": "Cancel",
    "create": "Create Phrase",
    "update": "Update Phrase",
    "toast": {
      "created": "Phrase created",
      "updated": "Phrase updated",
      "saveFailed": "Failed to save phrase",
      "keyMustStartWithDot": "Key must start with \".\"",
      "keyTooShort": "Key must be at least 2 characters",
      "expansionRequired": "Expansion text is required"
    }
  },
  "category": {
    "general": "General",
    "physicalExam": "Physical Exam",
    "reviewOfSystems": "Review of Systems",
    "assessment": "Assessment",
    "plan": "Plan",
    "instructions": "Instructions",
    "medications": "Medications",
    "history": "History"
  }
}
